import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';

import Auth from '@occc-app/Auth';
import Login from '@occc-app/Login';

export const UnauthenticatedApp = () => {
  return (
    <RouterRoutes>
      <Route path='/auth/login' element={<Auth />} />
      <Route path='/' element={<Login />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </RouterRoutes>
  );
};
